import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_EXAM_QUESTION,
  ADD_EXAM_QUESTION,
  UPDATE_EXAM_QUESTION,
  DELETE_EXAM_QUESTION,
  GET_EXAM_QUESTIONS_PAGINATION,
  CHECK_CAN_UPDATE_OR_DELETE,
  DELETE_ALL_EXAM_QUESTION,
} from '@/queries/modules/examination/exam-question.js';

export async function getExamQuestion(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_EXAM_QUESTION,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;


    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getExamQuestion
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
export async function checkCanUpdateOrDeleteExamQuestion(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: CHECK_CAN_UPDATE_OR_DELETE,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;


    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.checkCanUpdateOrDeleteExamQuestion
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
export async function getExamsPagination(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_EXAM_QUESTIONS_PAGINATION,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.examQuestionsPagination;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}
export async function addExamQuestion(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_EXAM_QUESTION,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', newItemSuccess(data.addExamQuestion.nameLocal));

      return data.addExamQuestion;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateExamQuestion(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_EXAM_QUESTION,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', updateItemSuccess(data.updateExamQuestion.nameLocal));
      return data.updateExamQuestion
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteExamQuestion(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_EXAM_QUESTION,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', deleteItemSuccess(data.deleteExamQuestion.nameLocal));

      return data.deleteExamQuestion
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteAllExamQuestion(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_ALL_EXAM_QUESTION,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', deleteItemSuccess());

      return data.deleteExamQuestion
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

